var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-8 px-5",staticStyle:{"min-height":"calc(100vh - (112px + 2.75rem))"}},[_c('iframe',{attrs:{"id":"logmaster-integration-main-iframe","width":"100%","height":"100%","src":_vm.external_url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }